import toastService from "./toast.service";
import toastSuccess from "./toast.success";
import toastError from "./toast.error";
import toastWarning from "./toast.warning";
import toastInfo from "./toast.info";
import ToastContent from "./ToastContent";
import { showToast, getText } from "./toast.utils";

export {
    toastService,
    toastSuccess,
    toastError,
    toastWarning,
    toastInfo,
    ToastContent,
    showToast,
    getText
};

export default toastService;
